import { useState } from "react";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import images from "../../assets/images";
import { getLocalization } from "../../redux/localization";

const ThirdSection = () => {
  const [active, setActive] = useState("1");
  const t = useSelector(getLocalization);
  return (
    <section className="adSection3">
      <img src={images.section3} alt="Rentificial" />
      <Container>
        <Row>
          <Col md={5}>
            <div className="section3Tab">
              <div
                className={
                  active === "1"
                    ? "borderRight active h-100"
                    : "borderRight h-100"
                }
                onClick={() => setActive("1")}
              >
                {t.getString("Advantages")}
              </div>
              <div
                className={active === "2" ? " active h-100" : " h-100"}
                onClick={() => setActive("2")}
              >
                {t.getString("Management")}
              </div>
            </div>
            {active === "1" && (
              <>
                <h2>{t.getString("Asset Rental Software")}</h2>
                <p className="mt-3">
                  {t.getString(
                    "Rentificial is a mobile rental management software which eases the renting services management and operate in integration with websites It is an application which provides detailed data entry opportunity by which various vehicle renting or good renting firms use and benefit"
                  )}
                </p>
              </>
            )}
            {active === "2" && (
              <>
                <h2>{t.getString("Rental Management")}</h2>
                <p>
                  {t.getString(
                    "Service track might be difficult for big renting firms How long for whom and for how much has the product been rented How much is the income totally in a month or term You can receive the answers of all such questions from a single application Various stages such as availability statuses of the vehiclesgoods rented maintenance track income can be followed up by the application"
                  )}
                </p>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default ThirdSection;
